import { openModal } from "../redux/modal/modalActions";
import ResponseModal from "../components/common/modal/responseModal/ResponseModal";

export const TASK_STATUS_SUCCESS_MESSAGE = {
  completed: "Task is completed successfully",
  notCompleted: "Task not completed successfully",
};

export function showTaskStatusErrorModal(dispatch, text) {
  dispatch(openModal(<ResponseModal text={text} isError={true} />));
}

export function showTaskStatusSuccessModal(dispatch, completedNow) {
  dispatch(
    openModal(
      <ResponseModal
        text={
          completedNow
            ? TASK_STATUS_SUCCESS_MESSAGE.completed
            : TASK_STATUS_SUCCESS_MESSAGE.notCompleted
        }
        isError={false}
        autoDismissAfterMs={3000}
      />,
    ),
  );
}
